import './DashboardMain.scss';

import React, { Fragment } from 'react';

import AllocationChart from 'components/charts/Allocation/AllocationChart';
import AccountLayoutHeader from 'components/layouts/AccountLayoutHeader/AccountLayoutHeader';
import DashboardTable from 'components/layouts/Account/DashboardTable';
import MobileDashboardTable from 'components/layouts/Account/MobileDashboardTable';
import WorkplaceRetirementSnapshot from 'components/layouts/Snapshot/WorkplaceRetirementSnapshot';
import RetailTracSnapshot from 'components/layouts/Snapshot/RetailTracSnapshot';
import { connect } from 'react-redux';
import {
  getHasOwnedCollegeSavingsOnly,
  getHasRetailTracAccounts,
  getHasWorkPlaceRetirementAccounts
} from 'state/account/AccountSelectors';

function DashboardMain({ view, allocations, hasWorkplaceRetirementAccounts, hasRetailTracAccounts, hasCollegeSavingsOnly }) {
  const {
    hasWorkplaceRetirementAccountsOnly,
    isDesktopLayout
  } = view;

  return (
    <Fragment>
      <div className="module-container">
        <AccountLayoutHeader
          text="Portfolio Snapshot"
          link="/accounts"
          detailText="View Account Details"
          isSubheader={false}
        />

        {!hasCollegeSavingsOnly &&
          !hasWorkplaceRetirementAccountsOnly &&
          isDesktopLayout && <AllocationChart allocations={allocations} />}

        {!hasWorkplaceRetirementAccountsOnly &&
          (isDesktopLayout ? <DashboardTable /> : <MobileDashboardTable />)}
      </div>

      {!hasCollegeSavingsOnly && hasWorkplaceRetirementAccounts && (
        <WorkplaceRetirementSnapshot />
      )}
      {!hasCollegeSavingsOnly && hasRetailTracAccounts && (
        <RetailTracSnapshot />
      )}
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  hasWorkplaceRetirementAccounts: getHasWorkPlaceRetirementAccounts(state),
  hasCollegeSavingsOnly: getHasOwnedCollegeSavingsOnly(state),
  hasRetailTracAccounts: getHasRetailTracAccounts(state)
});

export default connect(mapStateToProps)(DashboardMain)
